	//Set a value for session storage that the science page can than read to click the proper element (science-pre-selector.js)
	//Since the science page has a custom solution to clicking, we can't use default anchor tags and need a custom solution
	document
		.querySelectorAll(`[id*= "Collection-mega_menu"] > div > .mega_menu__inner > .mega_menu__sublinks > .mega_menu__sublinks-inner > a`)
		.forEach((elm, index) => {
			elm.addEventListener('click', function () {
				sessionStorage.setItem('scienceNavValue', index);
			});
		});